/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * カレンダマスタ情報
 */
export interface Szza023aRequestCalendarMasterInfo { 
    /**
     * カレンダコード：英数字
     */
    calendarCode: string;
    /**
     * 年：数字
     */
    year: string;
    /**
     * 月：数字
     */
    month: string;
    /**
     * 日：数字
     */
    date: string;
}

